export const BASE_URL = "https://dev.mentorx4u.com/api";

export const generatePublicUrlLocal = (fileName) => {
  return `https://dev.mentorx4u.com/public/${fileName}`;
};

